export default {
      id: "icon-status-deactive-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-status-deactive",
      toString: function () {
        return this.url;
      }
    }